// Landing headword rotator — the hero's dictionary line names ONE word (the garden
// the page is about) in every language the visitor can learn, one language at a
// time, cross-faded in place every 3 seconds.
//
// The variants are all rendered server-side, stacked in a single inline-grid cell
// (landing.css), so the box is as wide as the widest of them and the pos badge +
// gloss that follow never shift as the languages swap. All this script does is move
// two classes along; without it the first language simply stays up, which is exactly
// what a no-JS visitor sees.
//
// `leaving` is what makes the swap read as a roll UPWARD rather than a mush: with
// only `on`, the outgoing word would fall back to the same resting place the
// incoming one rises from, and the two would cross mid-air. The outgoing word gets
// its own exit — up and out of focus — while the next rises into it (landing.css).
//
// Its own file, not part of landing_garden.js: the two decorations are unrelated,
// and an exception in the garden must not stop the headword from cycling.
//
// `PL_LANDING_ENTRY.restart()` exists for exactly one caller: landing_lang.js, which swaps the
// reader language in place instead of reloading the page. The variant list is server-rendered,
// so a swap replaces the very nodes this closure is holding — without the restart the rotation
// would go on quietly moving classes around a detached NodeList.
(function () {
    "use strict";

    var PERIOD_MS = 5000;   // how long one language holds the line
    var EXIT_MS = 750;      // exit delay + duration; then the variant resets below

    var timer = null;

    function start() {
        if (timer) { clearInterval(timer); timer = null; }

        var head = document.querySelector(".landingEntryHeadClass");
        if (!head) { return; }
        var variants = head.querySelectorAll(".landingEntryLangClass");
        if (variants.length < 2) { return; }   // one language on offer: nothing to cycle

        var i = 0;
        timer = setInterval(function () {
            var out = variants[i];
            out.classList.remove("on");
            out.classList.add("leaving");
            // Back to the resting state below, ready for its next turn. Invisible by
            // then (the exit ends at opacity 0), so the reset itself is never seen.
            setTimeout(function () { out.classList.remove("leaving"); }, EXIT_MS);
            i = (i + 1) % variants.length;
            variants[i].classList.add("on");
        }, PERIOD_MS);
    }

    window.PL_LANDING_ENTRY = { restart: start };
    start();
})();
